import React from 'react'
import { Link } from 'react-router-dom'

function Refund() {
  return (
    <div className="legal-page">
        
        <p>At Amfia Education, we value your trust and aim to provide a smooth and transparent experience. Please read our cancellation and refund policy carefully. </p>

<h5>Cancellation Policy:</h5>
<p>Cancellations will be considered only within 15 days of course registration. </p>

<p>Cancellations will not be accepted once classes have started or digital material has been accessed/downloaded. </p>

<p>Any cancellation request must be made by emailing us at contact@amfiaeducation.com with the registration details. </p>

<h5>Refund Policy:</h5>
<p>Refunds are only processed if a genuine issue is found with course access, delivery, or quality, and must be reported within 15 days of registration. </p>

<p>We do not offer refunds once: </p>

<p>A minimum of 15 classes are attended </p>

<p>Worksheets or certificates are downloaded </p>

<p>If a refund is approved, the amount will be credited within 6–8 business days to the original payment method. </p>

<h5> Non-refundable Situations:</h5>
<p>Refunds will not be issued for change of mind, child disinterest, or partial attendance. </p>

<p>Fees for any teacher training programs, scholarship processing, or administrative services are non-refundable. </p>
<Link to='/shipping'><p>Shipping</p></Link>

<p>For any questions or refund-related support, please contact our team: </p>
<p>📧 contact@amfiaeducation.com </p>
       
    </div>
  )
}

export default Refund